import * as d3 from 'd3-selection'
import milestone from './milestone.js'
import task from './task/index.js'

var shapes = {
    milestone: milestone,
    task: task,
    initiative: task
  }

export default function (selection, defs, gantt) {
  selection.each(function (d) {
    return d3.select(this)
             .call(shapes[d.type], defs, gantt)
  })

}
